@if (details().error) {
    <div class="text-large leading-relaxed mb-3 text-red">{{ details().error }}</div>
} @else {
    <div class="text-large leading-relaxed mb-3">
        <div class="mt-2">
            {{ actionLabel() }} <span class="text-bold">{{ details().object_name }}</span>
            @if (details().object_type_label) {
                <span> ({{ details().object_type_label }})</span>
            }
        </div>
        @if (details().alert_type_label) {
            <div class="mt-2"><span class="text-bold">Alert type:</span> {{ details().alert_type_label }}</div>
        }
        @if (isEdit()) {
            @if (details().current_description) {
                <div class="mt-2">
                    <span class="text-bold">Current condition:</span> {{ details().current_description }}
                </div>
            }
            @if (hasCondition()) {
                <div class="mt-2"><span class="text-bold">New condition:</span> {{ details().description }}</div>
            }
        } @else if (hasCondition()) {
            <div class="mt-2"><span class="text-bold">Condition:</span> {{ details().description }}</div>
        }
    </div>
}
